import React from 'react'
import {Container, Divider, Header, Image} from 'semantic-ui-react'
import PlaceholderComponent from './PlaceholderComponent'
import {useGetTestQuery} from '../store/testsSlice'
import DOMPurify from "dompurify";
import VideoEmbed from './VideoEmbed'

// TODO implement
const OverviewUser = ({testId}) => {
    // console.log('testId:', testId)
    const {
        data: test,
        isLoading: isTestLoading,
        isError: isTestError,
        error: testError,
        isSuccess: isTestSuccess,
        refetch: testRefetch
    } = useGetTestQuery(testId);

    const sanitizedData = (htmlData) => ({
        __html: DOMPurify.sanitize(htmlData)
    })

    return (
        <Container style={{marginTop: '2rem', marginBottom: '2rem'}} text>
            {isTestSuccess
                ? (
                    <Container style={{marginTop: '2rem', marginBottom: '2rem'}}>

                        <Container>
                            <Header as={'h1'}>{test?.['product_summary']?.['title']}</Header>
                            <Header as={'h3'}>{test?.['product_summary']?.['subtitle']}</Header>
                        </Container>

                        {
                            test?.['product_summary']?.['video'] &&
                            <>
                                <Divider/>

                                <VideoEmbed
                                    url={test?.['product_summary']?.['video']}
                                    placeholder={test?.['product_summary']?.['video_placeholder']}
                                />
                            </>
                        }

                        {
                            test?.['product_summary']?.['image'] &&
                            <Container text textAlign={'center'}>
                                <Divider/>

                                <Image
                                    rounded
                                    fluid
                                    size={'large'}
                                    src={test?.['product_summary']?.['image']}
                                />
                            </Container>
                        }

                        <Divider/>

                        <Container
                            style={{marginTop: '2rem', marginBottom: '2rem'}}
                            text
                            dangerouslySetInnerHTML={sanitizedData(test?.product_summary?.overview)}
                        />
                    </Container>
                )
                : <PlaceholderComponent/>}

        </Container>
    )
}

export default OverviewUser
